// extracted by mini-css-extract-plugin
export var li = "QA-module--li--76f02";
export var root = "QA-module--root--71f4e";